import React from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import { injectIntl } from 'react-intl';
import treeChanges from 'tree-changes';

import { Card, Collapse } from 'antd';
import CriteriaForm from './CriteriaForm';
import ReportTable from './ReportTable';

import TransferInTrackingReportActions from '../../Stores/TransferInTrackingReport/Actions';

const { Panel } = Collapse;

class TransferInTrackingReportScreen extends React.PureComponent {
  componentDidMount() {
    const { curSiteFlowId, initTransferInTracking } = this.props;

    if (curSiteFlowId > 0) {
      initTransferInTracking();
    }
  }

  componentDidUpdate(prevProps) {
    const { curSiteFlowId, initTransferInTracking } = this.props;
    const { changed } = treeChanges(prevProps, this.props);

    if (changed('curSiteFlowId')) {
      if (curSiteFlowId > 0) {
        initTransferInTracking();
      }
    }
  }

  componentWillUnmount() {}

  render() {
    const { intl, match } = this.props;

    return (
      <Card title={intl.formatMessage({ id: 'goods_receipt_tracking_report' })}>
        <Collapse defaultActiveKey={['2']}>
          <Panel header={intl.formatMessage({ id: 'criteria' })} key="1">
            <CriteriaForm match={match} />
          </Panel>
          <Panel header={intl.formatMessage({ id: 'report' })} key="2">
            <ReportTable match={match} />
          </Panel>
        </Collapse>
      </Card>
    );
  }
}

TransferInTrackingReportScreen.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  intl: PropTypes.object,
  // eslint-disable-next-line react/forbid-prop-types
  match: PropTypes.object,

  initTransferInTracking: PropTypes.func,
  curSiteFlowId: PropTypes.number
};

TransferInTrackingReportScreen.defaultProps = {
  intl: {},
  match: {},

  initTransferInTracking: {},
  curSiteFlowId: 0
};

const mapStateToProps = state => ({
  curSiteFlowId: state.app.curSiteFlowId
});

const mapDispatchToProps = dispatch => ({
  initTransferInTracking: () =>
    dispatch(TransferInTrackingReportActions.transferInTrackingReportInitTransferInTracking())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(TransferInTrackingReportScreen));
